import { combineReducers } from '@reduxjs/toolkit';
import { editSlice } from '../edit/store';
import { portfoliosSlice } from '../portfolios/store';
import { TemplatesState } from './types';

export const templatesReducer = combineReducers<TemplatesState>({
  portfolios: portfoliosSlice.reducer,
  edit: editSlice.reducer,
});
